var _g, _rect;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEditIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Component_1_37",
    "data-name": "Component 1 \\u2013 37",
    xmlns: "http://www.w3.org/2000/svg",
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Ic_edit",
    transform: "translate(7 7.926)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_423",
    "data-name": "Path 423",
    d: "M128.274,46.311a.541.541,0,0,0-.758,0L116.363,57.446a.541.541,0,0,0-.144.271l-.632,2.869a.541.541,0,0,0,.523.65h.108l2.869-.632h0a.541.541,0,0,0,.271-.144l11.153-11.153a.541.541,0,0,0,0-.758ZM118.98,59.3l-1.462-1.462,9.059-9.059,1.48,1.48Z",
    transform: "translate(-115.577 -46.156)",
    fill: "#3957af"
  }))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_16",
    "data-name": "Rectangle 16",
    width: 30,
    height: 30,
    fill: "none"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEditIcon);
export default __webpack_public_path__ + "static/media/edit_icon.549676f9190de4975303d7547b43781a.svg";
export { ForwardRef as ReactComponent };